import { Component } from 'react';
import { connect, PromiseState } from 'react-refetch';
import Helmet from 'react-helmet';

import $ from 'jquery';
import MobileDetect from 'mobile-detect';
const isMobile = !!new MobileDetect(navigator.userAgent).mobile();
import { GoogleMap, GoogleMapLoader, Marker } from 'react-google-maps';
import classNames from 'classnames';

import { api, gmap, titles } from '../data';

import LoadingAnimation from './modules/LoadingAnimation';
import Title from './modules/Title';

class Gmap extends Component {

  render() {
    const mapInfo = this.props.mapInfo;
    const mapStyles = [{"featureType": "administrative","elementType": "labels.text.fill","stylers": [{"color": "#444444"}]},{"featureType": "landscape","elementType": "all","stylers": [{"color": "#f2f2f2"}]},{"featureType": "landscape","elementType": "geometry","stylers": [{"color": "#fffffa"}]},{"featureType": "landscape.man_made","elementType": "geometry.fill","stylers": [{"color": "#fffffa"}]},{"featureType": "poi","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "road","elementType": "all","stylers": [{"saturation": -100},{"lightness": 45}]},{"featureType": "road","elementType": "geometry.fill","stylers": [{"hue": "#ff0000"}]},{"featureType": "road.highway","elementType": "all","stylers": [{"visibility": "simplified"}]},{"featureType": "road.highway","elementType": "geometry","stylers": [{"color": "#fdcfdd"}]},{"featureType": "road.arterial","elementType": "labels.icon","stylers": [{"visibility": "off"}]},{"featureType": "transit","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "water","elementType": "all","stylers": [{"color": "#5b8ece"},{"visibility": "on"}]}];
    const myLatLng = new google.maps.LatLng(mapInfo.lat, mapInfo.lng);
    const markerIcon = gmap.markerIcon;

    return (
      <GoogleMapLoader
        googleMapElement={
          <GoogleMap
            defaultZoom={14}
            defaultCenter={myLatLng}
            defaultOptions={{ styles: mapStyles}}>
            <Marker
              ref="marker"
              position={myLatLng}
              icon={markerIcon}
            />
          </GoogleMap>
        }
      />
    )
  }
}

class Recruit extends Component {

  openItem() {
    $('.recruit__block--recruit thead').on('click', (e) => {
      $(e.currentTarget).parent('table').toggleClass('active');
    });
  }

  componentDidMount() {
    this.openItem();
  }

  render() {

    const page = this.props.page;
    const basicInfo = page.acf.basic_info[0];
    const recruit = page.acf.recruit;

    return (
      <div>
        <Helmet title={titles.recruit} titleTemplate={titles.titleTemplate} />
        <section className="recruit">
          <Title header="h1" title="求人情報" />
          <div className="recruit__content">
            <article className="recruit__block recruit__block--info">
              <Title header="h2" title="基本情報" />
              {basicInfo || basicInfo.length
                ?
                  <table>
                    <tbody>
                      {/* 事業所名 */}
                      {basicInfo.name
                        ?
                          <tr>
                            <th>事業所名</th>
                            <td>{basicInfo.name}</td>
                          </tr>
                        : ''
                      }

                      {/* 住所 */}
                      {basicInfo.address
                        ?
                          <tr>
                            <th>住所</th>
                            <td>{basicInfo.address}</td>
                          </tr>
                        : ''
                      }

                      {/* 連絡先 */}
                      {basicInfo.contact
                        ?
                          <tr>
                            <th>連絡先</th>
                            <td dangerouslySetInnerHTML={{__html: basicInfo.contact}} />
                          </tr>
                        : ''
                      }

                      {/* 勤務 */}
                      {basicInfo.work_env
                        ?
                          <tr>
                            <th>勤務</th>
                            <td dangerouslySetInnerHTML={{__html: basicInfo.work_env}} />
                          </tr>
                        : ''
                      }

                      {/* 選考プロセス */}
                      {basicInfo.selection_process
                        ?
                          <tr>
                            <th>選考プロセス</th>
                            <td dangerouslySetInnerHTML={{__html: basicInfo.selection_process}} />
                          </tr>
                        : ''
                      }

                      {/* アクセスマップ */}
                      {basicInfo.map
                        ?
                          <tr className="gmap">
                            <th>アクセスマップ</th>
                            <td><Gmap mapInfo={basicInfo.map} /></td>
                          </tr>
                        : ''
                      }
                    </tbody>
                  </table>
                : ''
              }
            </article>
            <article className="recruit__block recruit__block--recruit">
              <Title header="h2" title="募集状況" />
              {recruit || recruit.length
                ?
                  recruit.map(item => {
                    return (
                      <table key={item.title}>
                        <thead>
                          <tr>
                            <th colSpan="2">{item.title}</th>
                          </tr>
                        </thead>
                        <tbody className={classNames({'mobile': isMobile})}>
                          {item.item.map(colum => {
                            return (
                              <tr key={colum.title}>
                                <th>{colum.title}</th>
                                <td dangerouslySetInnerHTML={{__html: colum.content}} />
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    )
                  })
                : ''
              }
            </article>
          </div>
        </section>
      </div>
    )
  }
}

class RecruitFetch extends Component {
  render() {

    const { pageFetch } = this.props;

    const allFetches = PromiseState.all([pageFetch])

    // Pending
    if (allFetches.pending) {

      return <LoadingAnimation />

    // Error
    } else if (allFetches.rejected) {

      return <div>Error</div>

    // Complete without Error
    } else if (allFetches.fulfilled) {

      let [page] = allFetches.value;
      page = page[0];

      return (
        <Recruit page={page} />
      )
    }
  }
}

export default connect(() => ({
  pageFetch: `${api.base_url}/pages?slug=recruit`
}))(RecruitFetch);



/** WEBPACK FOOTER **
 ** ./src/components/Recruit.js
 **/